$(function() {

//==========================================================================
// STATE
//==========================================================================

var $header    = $('header.cabecera-landing').eq(0);
var $sticky    = $header.find('.sticky');
var headerH    = $header.outerHeight();
var isShown    = false;
var canAnimate = checkCanAnimate();

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

function init() {

    // if the page doesn't have the header with a sticky, abort
    if (!$sticky.length) return;

    // grab the title for the sticky header
    grabTitle($header, $sticky);

    // if we can animate, hide with transform instead of display
    if (canAnimate) $sticky.addClass('animation-hide').show();

    // on scroll show and hide the sticky
    $(window).on('scroll touchmove', updateStickyHeader);
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================

//-----

/**
 * Grab the title from the real header
 *
 * Populate the sticky header title with the text of the real header title.
 *
 * @param      {JQuery}  $header  The header.
 * @param      {JQuery}  $sticky  The sticky.
 */
function grabTitle($header, $sticky) {
    $sticky.find('h1').text($header.find('h1').text());
}

//-----

/**
 * Return true if the browser supports animations and is not <= IE 11.
 *
 * The IE restrictions are due to the fact that there's a a bug were
 * percentages in transforms used in animations are always treated as
 * pixels on windows 7.
 *
 * @see http://caniuse.com/#feat=css-animation
 */
function checkCanAnimate() {
    var ieVersion = bbva.tools.getIEVersion();
    return !((ieVersion && ieVersion <= 11) || !checkAnimation());
}

//-----

/**
 * Check if this browser supports CSS animation
 *
 * Ripped from MDN, check if the browser supports CSS animation looking
 * at the style properties of a div. Return whether it does.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations
 * /Detecting_CSS_animation_support
 */
function checkAnimation() {

    // assume no animation, and define prefixes, de div, etc
    var domPrefixes = ['Webkit', 'Moz', 'O', 'ms', 'Khtml'],
        elm = document.createElement('div')
    ;

    // if the animation property is there, we're done
    if (defined(elm.style.animationName)) {
        return true;
    }

    // otherwise, try all prefixes and return if someone works
    return !!__(domPrefixes).find(function(prefix) {
        return defined(elm.style[prefix + 'AnimationName']);
    });
}

//-----

//===== EVENTS =============================================================

//-----

/**
 * Show and hide the sticky header
 *
 * When the scroll is of more height than the header, show the sticky
 * header. When it's less or equal, hide it.
 */
function updateStickyHeader() {

    var offset = $(window).scrollTop();

    // if the sticky should be shown
    if (!isShown && offset > headerH) {

        // show the sticky
        (canAnimate)
            ? $sticky.removeClass('slide-up').addClass('slide-down')
            : $sticky.show()
        ;

        // remember it's shown
        isShown = true;

        // we can be done now
        return;
    }

    // if the sticky should be hidden
    if (isShown && offset <= headerH) {

        (canAnimate)
            ? $sticky.removeClass('slide-down').addClass('slide-up')
            : $sticky.hide()
        ;

        // remember it's hidden
        isShown = false;
    }
}

//-----

});
